import React from 'react';
import Address from '../../Components/Address/Address';
import RadialChart from "../../Components/Ui/RadialChart.jsx";
import "./WidgetsMarketing.scss";
import mab from "../../Assets/map.png"
import insta from "../../Assets/insta.png"
import bar from "../../Assets/bar-hr.png"
import Piechart from "../../Components/Ui/Piechart-marketing.jsx"
import Succ from "../../Assets/successarrow.png"
import VerticalBarChart from '../../Components/Ui/VerticalBarChart.jsx';
import tiktok from "../../Assets/tik.png"
import growth from "../../Assets/image (200).png"
import Follow from "../../Assets/image (205).png"
import Unfolow from "../../Assets/image (202).png"
export default function WidgetsMarketing() {
  return (
    <div className='p-3'>
        <Address title="chart Graphs Marketing" />
        <div className='row  mt-5   justify-content-center d-flex  gap-5'>
          <div className='col-4  redial-charddiv'>
            {/* <div className=' titlee'>Best seller</div> */}
            <div >
  <RadialChart />
            <ul className=' d-flex  justify-content-center align-items-center'>
                <div> <li>E-book</li></div>
             <div>
<li>Social Media</li>
             </div>
              <div>
 <li>Other</li>
              </div>
             
            </ul>
            </div>
          
          </div>

          <div className='col-7 mab-div'>
            <div className=' d-flex justify-content-between'>
                <h3>Top Countries Marketing</h3>
                <button><img src={insta}  className='insta-img'  alt="" />Instagram</button>
            </div>
           <img src={mab}  alt="" />
           <img src={bar} alt="" />
          </div>
        </div>

        <div className=' row  mt-3   justify-content-center d-flex  gap-5'>
             <div className='col-4 p-5  redial-charddiv2'>
             <div className=' d-flex justify-content-between mb-5'>
                <h3>Register  vs visits</h3>
               <div className='today'>Today</div>
            </div>
            <div className=' d-flex justify-content-center align-items-center flex-column'>
                 <Piechart className="mb-5"/>
          
           <ul className='second-list mt-5'>
            <div className='d-flex gap-4 align-items-center'>
               <li>Total Register</li>
               <div className='d-flex gap-2 align-items-center'>
               <span >54%</span>
               <img src={Succ} width={15} height={15} alt="" />
               </div>

            </div>
   <div className='d-flex gap-4 align-items-center'>
               <li>Register</li>
               <div className='d-flex gap-2 align-items-center'>
               <span >54%</span>
               <img src={Succ} width={15} height={15} alt="" />
               </div>

            </div>

               <div className='d-flex gap-4 align-items-center'>
               <li>visits</li>
               <div className='d-flex gap-2 align-items-center'>
               <span >54%</span>
               <img src={Succ} width={15} height={15} alt="" />
               </div>

            </div>
            </ul>
            </div>
         
          </div>
            <div className='redial-charddiv2 col-7 '>
               
 <div className=' d-flex justify-content-between  mb-4'>

                <h3>Followers</h3>
                <button><img src={tiktok}  className='insta-img'  alt="" />Instagram</button>
            </div>
            <div>
                <div className=' d-flex w-auto  gap-2'>
                     <div>
                    <span className='bold'>Net Growth</span>
                    <p>Jun 2024 - Dec 2024</p>
                </div>
                    <div className='Growth-div d-flex align-items-center  '>
                    <div>
<img src={Follow} width={40} height={40} alt="" />
<h6>Growt</h6>
                    </div>
<div>
    <span style={{color:"#01a2f1", fontWeight:"bold", fontSize:"20px"}}>23,430</span>
    <div>
           <span className=' me-3'>+412</span>
           <span style={{color:"#01a2f1"}}>23%</span>

    </div>
 
    
</div>
                    </div>

   <div className='Growth-div2 d-flex align-items-center '>
                    <div>
<img src={Unfolow} width={40} height={40} alt="" />
<h6>Growt</h6>
                    </div>
<div>
    <span style={{color:"#01a2f1", fontWeight:"bold", fontSize:"20px"}}>23,430</span>
    <div>
           <span className=' me-3'>+412</span>
           <span style={{color:"#01a2f1"}}>23%</span>

    </div>
 
    
</div>
                    </div>


    

     <div className='Growth-div2 d-flex align-items-center '>
                    <div>
<img src={growth} width={40} height={40} alt="" />
<h6>Growt</h6>
                    </div>
<div>
    <span style={{color:"#01a2f1", fontWeight:"bold", fontSize:"20px"}}>23,430</span>
    <div>
           <span className=' me-3'>+412</span>
           <span style={{color:"#01a2f1"}}>23%</span>

    </div>
 
    
</div>
                    </div>

     
                </div>

            </div>
           <VerticalBarChart/>
            </div>
        </div>
    </div>
  );
}
